import styled from 'styled-components';

const StyledScatter = styled.div`

	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right 0;


	.af-title {
		position: absolute;
		top: 0;
		left:0;
		right: 0;
		color: #fff;
		padding-top: 30px;
		font-family: 'Sans', 'RijksoverheidSansText-Regular', 'RijksoverheidSansText', Arial, sans-serif;
		font-weight: 600;
		font-size: 21px;
	}

	.af-legend {
		position: absolute;
		bottom: 30px;
		left:0;
		right: 0;
		font-family: 'Sans', 'RijksoverheidSansText-Regular', 'RijksoverheidSansText', Arial, sans-serif;
		text-align: left;
		color: #fff;
		font-size: 15px;
		font-weight: 600;
		list-style: none;
		li {
			display: inline;
		}
		span {
			display: inline-block;
		}
	}

	.af-source {
		position: absolute;
		bottom: 0;
		left:0;
		right: 0;
		color: #fff;
		font-family: 'Sans', 'RijksoverheidSansText-Regular', 'RijksoverheidSansText', Arial, sans-serif;
		font-weight: 400;
		text-align: right;
		padding: 15px;
		font-size: 12px;
		font-family: sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		a {
			color: #fff;
		}
	}

	.af-tooltip-scatter {
      position: absolute;
      display: none;
      background-color: #333;
      padding: 15px;
      border-radius: 6px;
      color: #fff;
      font-family: sans-serif;
      font-size: 12px;
      height: auto;
      table {
      	tbody {
      		border-top: none;
      	}
      	td {
      		text-align: left;
      	}
      	td:last-of-type {
      		text-align: right;
      	}
      }
	}

	svg {
    width: 100%;
    height: 100%;

		text {
			font-family: 'Sans', 'RijksoverheidSansText-Regular', 'RijksoverheidSansText', Arial, sans-serif;
		}

		.axis {
			text {
				font-size: 15px;
			}
		}

		.af-barchart-tooltip {
			text {
				font-size: 18px;
			}
		}

		path {
		  stroke: #fff;
		  stroke-width: 2;
		}

	}


}
`;

export default StyledScatter;



// WEBPACK FOOTER //
// ./src/components/Scatter/StyledScatter.js